import { render, staticRenderFns } from "./commission_staff.vue?vue&type=template&id=8c9638bc&"
import script from "./commission_staff.vue?vue&type=script&lang=js&"
export * from "./commission_staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports